import { FiStateSrefModule } from '@fi-shared/fi-state-proxy/state-sref/state-sref.module';
import { FiFormEditModule } from './fi-form-edit/fi-form-edit.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiFormService } from '@fi-app/fi-form/fi-form.service';
import { FiFormNavigationTabsComponent } from './fi-form-navigation-tabs/fi-form-navigation-tabs.component';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { UIRouterModule } from '@uirouter/angular';
import { FormStates } from '@fi-app/fi-form/fi-form-states';
import { FiFormListModule } from '@fi-app/fi-form/fi-form-list/fi-form-list.module';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { FiFormReportModule } from '@fi-app/fi-form/fi-form-report/fi-form-report.module';
import { FiFormViewerModule } from '@fi-app/fi-form/fi-form-viewer/fi-form-viewer.module';
import { FiFormTodoService } from '@fi-app/fi-form/fi-form-todo.service';
import { FiFormListExtendedSearchComponent } from '@fi-app/fi-form/fi-form-list-extended-search/fi-form-list-extended-search.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiFormActionsService } from '@fi-app/fi-form/fi-form-actions.service';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(FormStates),
        FiFormListModule,
        FiFormReportModule,
        FiTabsModule,
        ItemsListModule,
        FiFormEditModule,
        FiStateSrefModule,
        FiFormViewerModule,
        MatButtonModule,
        MatIconModule,
    ],
    declarations: [FiFormNavigationTabsComponent, FiFormListExtendedSearchComponent],
    providers: [FiFormService, FiFormActionsService, FiFormTodoService],
})
export class FiFormModule {}
